export function weeklyPick(datasetPrefix: string, weekendAsMonday = false) {
  const days = [
    'dimanche',
    'lundi',
    'mardi',
    'mercredi',
    'jeudi',
    'vendredi',
    'samedi',
  ];
  const dayNo = new Date().getDay();
  let day = days[dayNo];
  if (weekendAsMonday && ['samedi', 'dimanche'].includes(day)) {
    day = 'lundi';
  }
  return `${datasetPrefix}_${day}`;
}
